import * as Vuex from 'vuex'
import userInfo from '../store/modules/userInfo'
import dict from '../store/modules/dict'
import forLeave from "../store/modules/forLeave";
import approval from "../store/modules/approval";
import checkRule from "@/store/modules/checkRule";
import forTrip from '../store/modules/forTrip';
import forFieldWork from '../store/modules/forFieldWork';
import forBusiness from '../store/modules/forBusiness';
import forCar from '../store/modules/forCar';
import forSeal from '../store/modules/forSeal';
import forProject from '../store/modules/forProject';
import forContract from '../store/modules/forContract';
import forReimbursement from '../store/modules/forReimbursement';
import overTime from '../store/modules/overTime';
import log from '../store/modules/log';
import reCheckIn from '../store/modules/reCheckIn';
import general from '../store/modules/general';
import location from '../store/modules/location';
import workHours from '../store/modules/workHours'
import payslip from '../store/modules/payslip'

const store = Vuex.createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    userInfo,
    dict,
    forLeave,
    approval,
    checkRule,
    forTrip,
    forFieldWork,
    forBusiness,
    forCar,
    forSeal,
    forProject,
    forContract,
    forReimbursement,
    overTime,
    log,
    reCheckIn,
    general,
    location,
    workHours,
    payslip
  }
})
export default store
